import LtcProfit from './ltcProfit.png';
import DotProfit from './dotProfit.png';
import TrxProfit from './trxProfit.png';
import VetProfit from './vetProfit.png';

const ProfitExamples6 = () => {
  return (
    <div
      style={{
        flex: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <p style={{ fontSize: 24, fontWeight: 'bold' }}>
        Dino Coins Historical Profit
      </p>
      <div
        style={{
          display: 'grid',
          gridTemplateRows: 'repeat(2, 1fr)',
          gridTemplateColumns: 'repeat(2, 1fr)',
          height: '100%',
          width: '100%',
        }}
      >
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={LtcProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={DotProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={TrxProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={VetProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
      </div>
    </div>
  );
};

export default ProfitExamples6;
